import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import TopUpPaymentModal from '../../../../components/Shared/TopUpModal/TopUpPaymentModal'
import { Avatar } from '../../../../components/UI'
import MultiTalent from '../../../../components/Shared/MultiTalent'
import UpcomingClassLanguage from '../../../common/Statistic/UpcomingClassLanguage'
import TupUpPaymentModalPromoCode from '../../../../components/Shared/TopUpModal/TopUpPaymentModal/TupUpPaymentModalPromoCode'

import {
  bookStudentClassBanner,
  resetClassBannerBookingError,
} from '../../../../routing/fetchingfunction/classBannerBooking/classBannerBooking.actions'
import {
  selectErrorBookStudentClassBanner,
  selectLoadingBookStudentClassBanner,
} from '../../../../routing/fetchingfunction/classBannerBooking/classBannerBooking.reducer'

import { getUserName } from '../../../../helpers'

import { imagePrefix } from '../../../../constants'

const BookTutorPaymentModal = ({ data, open, onClose, onSuccess }) => {
  const dispatch = useDispatch()

  const classBanner = data?.classBanner
  const selectedSlot = data?.selectedSlot
  const hour = parseFloat(selectedSlot?.slot)

  const isLoading = useSelector(selectLoadingBookStudentClassBanner)
  const error = useSelector(selectErrorBookStudentClassBanner)

  const handleResetError = () => {
    dispatch(resetClassBannerBookingError())
  }

  const handlePayment = (data) => {
    // TODO: add payment id
    dispatch(
      bookStudentClassBanner({
        availability_calendar: selectedSlot.pk,
        payment_id: 'gfdsxazgvfdcx',
      })
    ).then((response) => {
      if (!response.error) {
        onSuccess(classBanner)
      }
    })
  }

  const handleApplyPromoCode = (data) => {}

  const handleRenderInfo = () => {
    if (!classBanner) {
      return null
    }

    return (
      <div className="shadow-modal-light w-[480px] mr-[20px] p-[24px] rounded-[10px] border-[#FFCA84] border-[1px] bg-[#FFF5EE]">
        <div className="w-full flex items-center p-[24px] rounded-t-[10px] border-b-[rgba(247,144,9,0.40)] border-b-[1px] bg-white">
          <div className="flex items-center justify-center mr-[24px]">
            <Avatar
              src={`${imagePrefix}${classBanner.class_banner_creator?.profile_picture}`}
              gender={classBanner.creator_profile?.gender}
              className="w-[100px] h-[100px]"
            />
          </div>

          <div className="flex-1 overflow-hidden flex items-start flex-col gap-y-[8px]">
            {/* TODO */}
            {true && <MultiTalent />}

            <h2 className="text-2xl font-bold text-primary-100 w-full text-ellipsis whitespace-nowrap overflow-hidden">
              {getUserName(
                classBanner.class_banner_creator,
                classBanner.creator_profile?.display_name,
                classBanner.creator_profile?.display_last_name
              )}
            </h2>

            <div className="flex justify-center gap-x-[16px]">
              <div className="flex justify-center items-center">
                <img
                  className="w-[24px] h-[24px]"
                  src={'/assets/icon/checkbox-multiple-line.svg'}
                  alt="Checkbox"
                />

                <span className="font-normal ml-1 text-sm text-[#F67443]">
                  {classBanner.tutor_stats?.total_bookings || 0}
                </span>
              </div>

              <div className="flex justify-center items-center">
                <img className="w-[24px] h-[24px]" src={'/assets/icon/user-green.svg'} alt="User" />

                <span className="font-normal ml-1 text-sm text-[#F67443]">
                  {classBanner.tutor_stats?.total_students || 0}
                </span>
              </div>

              <div className="flex justify-center items-center">
                <img className="w-[24px] h-[24px]" src={'/assets/icon/star.svg'} alt="Star" />
                <span className="font-normal ml-1 text-sm text-[#F67443]">
                  {classBanner.tutor_stats?.overall_rating_average || 0}
                </span>
              </div>
            </div>

            <div className="w-full flex items-center flex-wrap gap-y-[8px]">
              <div className="flex items-center mr-[16px]">
                <img src="/assets/icon/lang.svg" alt="Language" className="mr-[8px]" />

                <ul className="flex items-center gap-x-[4px]">{languagesContent}</ul>
              </div>

              {/* TODO */}
              <div className="flex items-center">
                <div className="flex items-center mr-[10px]">
                  <img src={'/assets/icon/globleIcon.png'} />
                  <img src={`/assets/icon/britain.png`} className="w-[24px] h-[24px] ml-[4px]" />
                </div>

                <div className="flex items-center">
                  <img src={`/assets/icon/homeOrangeIcon.png`} />
                  <img src={`/assets/icon/poland.png`} className="w-[24px] h-[24px] ml-[4px]" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-[24px] w-full flex flex-col items-start">
          <span className="text-base font-bold text-primary-100">Your Booking Details</span>

          <div className="w-full flex flex-col items-start gap-y-[10px] mt-[10px]">
            <div className="w-full flex items-end justify-between">
              <span className="text-[14px] text-primary-100 font-medium">Class</span>

              <span className="text-sm text-primary-100 font-semibold">
                {classBanner.class_banner_category.name}
              </span>
            </div>

            <div className="w-full flex items-end justify-between">
              <span className="text-[14px] text-primary-100 font-medium">Schedule</span>

              <span className="text-sm text-primary-100 font-semibold">
                {moment(selectedSlot?.day).format('dddd, MMM DD')} -{' '}
                {hour < 10 && hour > -1 ? `0${hour}` : hour}:00
              </span>
            </div>

            <div className="w-full flex items-end justify-between">
              <span className="text-[14px] text-primary-100 font-medium">Price</span>

              <span className="text-sm text-primary-100 font-semibold">
                € {classBanner.price_per_class}
              </span>
            </div>

            <TupUpPaymentModalPromoCode onApply={handleApplyPromoCode} />
          </div>

          <div role="separator" className="mt-[10px] w-full h-[1px] bg-[rgba(247,144,9,0.40)]" />

          <div className="w-full flex flex-col items-start gap-y-[10px] mt-[24px]">
            <div className="w-full flex items-center justify-between">
              <span className="text-base font-bold text-primary-100">Total</span>

              <span className="text-base text-primary-100 font-bold">
                € {classBanner.price_per_class}
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const languagesContent = (classBanner?.creator_profile?.languages || []).map((language) => {
    return <UpcomingClassLanguage key={`lang-${language.iso_639_1_code}`} language={language} />
  })

  return (
    <TopUpPaymentModal
      open={open}
      data={classBanner}
      openCheck="open"
      onClose={onClose}
      onPayment={handlePayment}
      renderInfo={handleRenderInfo}
      isLoading={isLoading}
      error={error}
      resetError={handleResetError}
    />
  )
}

export default BookTutorPaymentModal
